import React from "react";
import { AutoGiftEditContext } from "features/auto-gifts/contexts";

export const useAutoGiftEditContext = () => React.useContext(AutoGiftEditContext);
